import {useEffect, useState} from "react";
import {Fade, IconButton} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const ScrollToTopButton = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > 300);
        };

        handleScroll();
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <Fade in={visible}>
            <IconButton
                onClick={handleClick}
                aria-label="scroll to top"
                sx={(theme) => ({
                    position: "fixed",
                    bottom: 24,
                    right: 24,
                    width: 46,
                    height: 46,
                    zIndex: theme.zIndex.tooltip,
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                    border: `1px solid ${theme.palette.divider}`,
                    boxShadow: 2,
                    opacity: 0.6,
                    transition: "all 0.2s ease",
                    "&:hover": {
                        opacity: 1,
                        backgroundColor: theme.palette.background.paper,
                        transform: "translateY(-2px)",
                    },
                })}
            >
                <KeyboardArrowUpIcon />
            </IconButton>
        </Fade>
    );
};

export default ScrollToTopButton;